import {
  SET_MATERIALS,
  SET_MATERIALS_LOADING,
  SET_MATERIALS_ERROR,
  SET_MATERIAL_FORMULA,
  SET_MATERIAL_FORMULA_LOADING,
  SET_MATERIAL_FORMULA_ERROR,
} from "../../actions/materialAction";

var initialState = {
  datas: [],
  loading: false,
  error: null,
  formula: null,
  formulaLoading: false,
  formulaError: null,
};

const materialReducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case SET_MATERIALS:
      return {
        ...state,
        datas: action.data,
      };

    case SET_MATERIALS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case SET_MATERIALS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    case SET_MATERIAL_FORMULA:
      return {
        ...state,
        formula: action.data,
        formulaError: null,
      };
    case SET_MATERIAL_FORMULA_LOADING:
      return {
        ...state,
        formulaLoading: action.status,
      };
    case SET_MATERIAL_FORMULA_ERROR:
      return {
        ...state,
        formulaError: action.error,
      };
    default:
      return state;
  }
};

export default materialReducer;
